import { Trans, useLingui } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import Dialog from '@/design_system/Dialog';
import { Footer, FooterButtons } from '@/design_system/Footer';
import Paragraph from '@/design_system/Typography/Paragraph';
import { useBrandRequestContext } from '@/layouts/Brand/BrandRequestContext';
import { useDeleteArticle } from '@/models/article';

const EmptyCartModal = ({
  isOpen,
  onOpenChange,
  onDelete,
}: {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  onDelete?: () => void;
}) => {
  const { t } = useLingui();
  const { request } = useBrandRequestContext();

  const { mutateAsync: deleteArticle, isPending: isDeleteArticlePending } = useDeleteArticle();

  const handleDelete = async () => {
    await Promise.all(
      request.articles.map(async (article) => {
        await deleteArticle(article.id);
      })
    );

    onDelete?.();
  };

  return (
    <Dialog
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      title={t({
        id: 'client.new.cart.delete.modal.title',
        message: 'Empty your cart',
      })}
      style={{ maxWidth: '28rem' }}
    >
      <main style={{ paddingTop: 0 }}>
        <Paragraph>
          <Trans id="client.new.cart.delete.modal.text">
            You're about to empty your cart. All changes will be lost. Are you sure?
          </Trans>
        </Paragraph>
      </main>
      <Footer>
        <FooterButtons>
          <Button variant="secondary-brand" size="small" onPress={() => onOpenChange(false)}>
            <Trans id="client.new.cart.delete.modal.cancel">Cancel</Trans>
          </Button>
          <Button
            variant="danger"
            size="small"
            onPress={() => {
              handleDelete();
            }}
            isLoading={isDeleteArticlePending}
          >
            <Trans id="client.new.cart.delete.modal.empty">Empty</Trans>
          </Button>
        </FooterButtons>
      </Footer>
    </Dialog>
  );
};

export default EmptyCartModal;
